export const counter = {
  input: {
    countingVariable: "Zu zählende Elemente"
  }
};
